import FederationSummaryApiClient from "api/FederationSummaryApiClient";
import { useBuildReport } from "hooks/reports/useBuildReport";
import { ReportFormat } from "api/Enums";

export function useGenerateFederationSummary(options) {
    return useBuildReport(
        (federationId) =>
            FederationSummaryApiClient.buildFederationSummary(federationId, ReportFormat.Json),
        options,
    );
}
